"use client";

import React, { useEffect, useRef, useState } from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function HeritageHospitality() {
  const [scrollY, setScrollY] = useState(0);
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: imgRef,
    isVisible: isImgVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    if (typeof window !== "undefined") {
      window.addEventListener("scroll", handleScroll, {
        passive: true
      });
      return () => window.removeEventListener("scroll", handleScroll);
    }
  }, []);
  return <section data-section-id="223889" id="decades-of-advocacy" className="bg-background text-foreground relative w-full min-h-screen flex items-center overflow-hidden">
      {}
      <div className="absolute inset-0 z-0 opacity-[0.04] pointer-events-none bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662932/img/parchment_texture_overlay.png)] bg-repeat mix-blend-overlay" aria-hidden="true" />

      <div className="container mx-auto px-4 py-20 md:py-32 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-24 items-center">
          
          {}
          <div ref={imgRef} className={`lg:col-span-5 relative h-[60vh] lg:h-[85vh] w-full overflow-hidden rounded-sm transition-all duration-1000 ease-out ${isImgVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <div className="absolute inset-0 w-full h-[120%] -top-[10%] will-change-transform" style={{
            transform: `translateY(${scrollY * 0.15}px)`
          }}>
              
              {}
              
            </div>
          </div>

          {}
          <div ref={textRef} className={`lg:col-span-7 flex flex-col justify-center space-y-10 lg:pl-8 xl:pl-16 transition-all duration-1000 delay-200 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <div className="space-y-6">
              <h2 className="font-default text-4xl md:text-5xl lg:text-7xl font-light tracking-tighter text-primary">Building a Legacy</h2>
              <div className="w-20 h-[1px] bg-primary/50" />
            </div>

            <div className="space-y-6 text-muted-foreground font-default text-lg md:text-xl leading-relaxed max-w-2xl">
              <p className="!text-justify">Shaik Azrin &amp; Co was founded in 2004 by Shaik Azrin bin Shaik Daud. The firm's main area of expertise is Employment Law, Industrial Relations and Civil Litigation Law.</p>
              <p className="!text-justify">Shaik Azrin who has a Bachelor of Laws from International Islamic University (IIU) started off his career as a legal assistant at Shearn Delamore &amp; Co. During his time there, Shaik Azrin found his footing by independently conducting Industrial Court hearings, including full trials, submissions, and judicial review applications.<br /><br />Today, Shaik Azrin bin Shaik Daud now acts as lead counsel in Industrial Court trials, Judicial Review proceedings, and appellate matters before the Court of Appeal all while upholding the professional standards of Shaik Azrin &amp; Co.<br /><br />Together the two brothers, Shaik Azrin and Shaik Azrul continues Datuk Shaik Daud's legacy. The late Datuk was a renowned judge of the Court of Appeal who was known for handling notable cases such as The Kerry Wiley Case.<br />&nbsp;<br />&nbsp;</p>
            </div>

            <div className="pt-8 flex flex-col sm:flex-row items-start sm:items-center gap-8 border-t border-border/40">
              
              <div className="sm:ml-auto">
                <Button asChild variant="outline" size="lg" className="rounded-sm border-primary/30 hover:bg-primary hover:text-primary-foreground transition-colors font-default">
                  
                </Button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}